import React from 'react';
import { motion } from 'framer-motion';
import { Eye, BookOpen, Crown, Compass, Sparkles, HeartPulse, Heart, TrendingUp } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteBenefits() {
  const benefits = [{
    icon: Eye,
    title: 'Înveți să trăiești conștient în prezent',
    desc: 'Nu mai funcționezi pe pilot automat. Ești prezent/ă, atent/ă și conectat/ă cu ceea ce trăiești în fiecare moment. Viața capătă o altă calitate.'
  }, {
    icon: BookOpen,
    title: 'Descoperi și aplici cele 7 legi spirituale ale succesului',
    desc: 'Nu le doar citești, ci le practici. Fiecare lege devine un instrument pe care îl folosești zilnic ca să trăiești în armonie și să atragi ce îți dorești.'
  }, {
    icon: Crown,
    title: 'Îți schimbi perspectiva asupra prosperității',
    desc: 'Înțelegi că bogăția adevărată nu e doar financiară. E sănătate din plin, relații din plin, sens din plin. Și că toate vin când ești aliniat/ă cu tine.'
  }, {
    icon: Compass,
    title: 'Accesezi o stare de claritate și echilibru',
    desc: 'Confuzia dispare. Știi ce vrei, de ce vrei și cum să ajungi acolo. Nu mai oscilezi între dorință și nehotărâre.'
  }, {
    icon: Sparkles,
    title: 'Atragi spontan prosperitate și oportunități',
    desc: 'Nu prin strategie forțată, ci prin alinierea interioară. Când ești prezent/ă și conștient/ă, oportunitățile apar natural.'
  }, {
    icon: HeartPulse,
    title: 'Aplici exerciții practice pentru sănătate',
    desc: 'Tehnici concrete pe care le faci zilnic și care îți susțin corpul și energia. Nu doar "gândire pozitivă", ci practică reală.'
  }, {
    icon: Heart,
    title: 'Cultivi recunoștința și iubirea în viața ta',
    desc: 'Recunoștința nu e doar un concept frumos. E o practică zilnică care îți schimbă chimia interioară și felul în care experimentezi fiecare zi.'
  }, {
    icon: TrendingUp,
    title: 'Începi să îți transformi viața în mod real',
    desc: 'Nu doar să visezi la o viață mai bună, ci să o construiești conștient, zi de zi, cu pași mici și siguri.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2004">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2005">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-2006" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-2007">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-2008">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-2009">
                  <Icon className="w-8 h-8" data-id="element-2010" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-2011">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-2012">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2013">
          <CTAButton data-id="element-2014" />
        </motion.div>
      </div>
    </section>;
}